import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from '../base.service';
import { ImportResult } from '../../models/admin/branch-zipcode.model';

@Injectable()
export class BranchZipcodeService extends BaseService<any> {
	constructor(http: HttpClient) {
		super(http);
	}

	getBranchZipcodes(params: {
		search?: string;
		branch_id?: number;
		page?: number;
		per_page?: number;
	}): Observable<any> {
		const cleanParams: any = {};
		if (params.search) cleanParams.search = params.search;
		if (params.branch_id) cleanParams.branch_id = params.branch_id;
		if (params.page) cleanParams.page = params.page;
		if (params.per_page) cleanParams.per_page = params.per_page;
		return this.get('branch-zipcodes', cleanParams);
	}

	createBranchZipcode(data: any): Observable<any> {
		return this.create('branch-zipcodes', data);
	}

	updateBranchZipcode(id: number, data: any): Observable<any> {
		return this.http.put<any>(`${this.baseUrl}branch-zipcodes/${id}`, data);
	}

	deleteBranchZipcode(id: number): Observable<any> {
		return this.http.delete<any>(`${this.baseUrl}branch-zipcodes/${id}`);
	}

	importCSV(file: File): Observable<ImportResult> {
		const formData = new FormData();
		formData.append('file', file);
		return this.http.post<ImportResult>(`${this.baseUrl}branch-zipcodes/import`, formData);
	}

	downloadTemplate(): Observable<Blob> {
		return this.http.get(`${this.baseUrl}branch-zipcodes/template`, { responseType: 'blob' });
	}

	resolveBranchByZipcode(zipcode: string): Observable<{ data: { branch_id: number; branch_name: string } | null }> {
		return this.get('branch-zipcodes/resolve', { zipcode });
	}
}
